<template>
  <div class="form-row d-info admin-info">
    <p>
      Administratorem danych osobowych jest Autopay S.A. z siedzibą w Sopocie<span v-if="!showMore">. <a class="toggle-more" href="" @click.prevent="showMore = true">więcej</a></span>
      <span v-if="showMore"> ul. Powstańców Warszawy 6, 81-718 Sopot, rejestr przedsiębiorców prowadzony przez Sąd Rejonowy Gdańsk-Północ VIII Wydział Gospodarczy KRS, KRS 0000320590, NIP 585-13-51-185, REGON 191781561, kapitał zakładowy 2 205 500 PLN (w całości opłacony). Podanie danych osobowych jest dobrowolne, ale niezbędne do realizacji usługi.</span>
      Podstawa prawna, cel, okres przetwarzania danych osobowych oraz uprawnienia przysługujące Użytkownikowi, a także inne ważne informacje dotyczące zasad przetwarzania danych osobowych są szczegółowo określone w <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Polityce prywatności</a>.
    </p>
    <p>
      Autopay korzysta z plików cookie. Pozostając na tej stronie, wyrażasz zgodę na korzystanie z plików cookie zgodnie z <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Polityką prywatności Autopay S.A.</a> Możesz samodzielnie zarządzać cookies zmieniając odpowiednio ustawienia swojej przeglądarki lub oprogramowania urządzenia.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AdministratorDataInfo',
  data () {
    return {
      showMore: false
    }
  }
}
</script>
